<template>

  <div v-if="isAdBlocked"></div>

  <!-- Для прода -->
  <div v-else-if="isProdEnv" class="banner-container">
    <!--AdFox START-->
    <!--yandex_bimlib.ampleev-->
    <!--Площадка: BIMLIB / Широкий длинный: 1161x196 / площадка середина-->
    <!--Категория: <не задана>-->
    <!--Тип баннера: тип Широкий длинный: 1161x196-->
    <div class="banner-wrapper">
      <div id="adfox_163653435270138629"></div>
    </div>
  </div>

  <!-- Для дева -->
  <div v-else class="banner-container">
    <!--AdFox START-->
    <!--yandex_bimlib.ampleev-->
    <!--Площадка: BIMLIB / Широкий длинный: 1161x196 / площадка середина-->
    <!--Категория: <не задана>-->
    <!--Тип баннера: тип Широкий длинный: 1161x196-->
    <div class="banner-wrapper">
      <div id="adfox_16359446499109647"></div>
    </div>
  </div>
</template>

<script>
import Config from '@/config'
export default {
  name: 'AdfoxLongWide',
  mounted() {
    try {
      if (this.isProdEnv) {
        window.yaContextCb.push(()=>{
          Ya.adfoxCode.create({
            ownerId: 392411,
            containerId: 'adfox_163653435270138629',
            params: {
              p1: 'crefu',
              p2: 'hjxi'
            }
          })
        })
      } else {
        window.yaContextCb.push(()=>{
          Ya.adfoxCode.create({
            ownerId: 392411,
            containerId: 'adfox_16359446499109647',
            params: {
              p1: 'crbzr',
              p2: 'hjxi'
            }
          })
        })
      }
    } catch(e) {}
  },
  computed: {
    isProdEnv() {
      return Config.appEnv === 'prod'
    },
    isAdBlocked() {
      try {
        return !window.yaContextCb.queueId
      } catch(e) {}
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.banner-container {
  max-width: 100%;
  max-height: 196px;
  position: relative;
  box-sizing: border-box;

  @media screen and (max-width: 1161px) {
    height: calc(99vw / 5.92);
  }

  .banner-wrapper {
    display: flex;
    justify-content: center;
    position: relative;
    width: 99vw;
    left: 50%;
    transform: translateX(-50%);

    &::v-deep div > a {
      display: block;
      position: relative;
    }
  }

  &::v-deep .text-position-banner > a > div {
    left: 4px !important;
    top: 4px !important;
  }
}
</style>
